export default "__VITE_ASSET__C8yr6mAT__"